import { useMemo, useState } from 'react';
import { FundingPolicyType } from '@shared';
import { clientApplicationConsentIds, consents, type ConsentItem } from '@shared/consents';
import type { ConsumerQuote } from '@shared/consumerPlan';

/** The quote-and-apply consents for the chosen product, and which ones the consumer has accepted. */
export function useApplicationConsents(quote: ConsumerQuote | null) {
  const isCareScout = quote?.fundingPolicyType === FundingPolicyType.careScoutCareAssurance;
  const items = useMemo<ConsentItem[]>(
    () => clientApplicationConsentIds(isCareScout).map(id => consents[id]),
    [isCareScout],
  );
  const [accepted, setAccepted] = useState<Record<string, boolean>>({});

  return {
    items,
    accepted,
    setAccepted: (consentId: string, isAccepted: boolean) =>
      setAccepted(current => ({ ...current, [consentId]: isAccepted })),
    allAccepted: items.every(item => accepted[item.id]),
    consentIds: items.map(item => item.id),
  };
}
